import BaseSelect from 'components/Selects/BaseSelect/BaseSelect';
import { findSelectOption } from 'components/Selects/BaseSelect/utils/baseSelect.utils';
import './marineWidgetSelect.scss';

const marineWidgetSelectClassNames = {
  control: () => 'marine-widget-select-control',
  valueContainer: () => 'marine-widget-select-value',
  input: () => 'marine-widget-select-input',
  singleValue: () => 'marine-widget-select-value-text',
  placeholder: () => 'marine-widget-select-placeholder',
  indicatorsContainer: () => 'marine-widget-select-indicators',
  dropdownIndicator: () => 'marine-widget-select-dropdown-indicator',
  indicatorSeparator: () => 'marine-widget-select-separator',
  menu: () => 'marine-widget-select-menu',
  menuList: () => 'marine-widget-select-menu-list',
  option: () => 'marine-widget-select-option',
};

const MarineWidgetSelect = ({
  label,
  options = [],
  selectedValue,
  placeholder,
  isSearchable = false,
  onSelect,
}) => {
  return (
    <BaseSelect
      wrapperClassName="marine-widget-select"
      label={label}
      classNames={marineWidgetSelectClassNames}
      isSearchable={isSearchable}
      selectProps={{
        options,
        value: findSelectOption(options, selectedValue),
        isDisabled: options.length < 2,
        onChange: (option) => onSelect(option?.value),
        placeholder,
      }}
    />
  );
};

export default MarineWidgetSelect;
